import React, { useState, useEffect } from "react";
import { RecoilRoot } from "recoil";
import "./App.css";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import Login from "./components/Login";
import Home from "./components/Home";
import Member from "./components/Member";
import User from "./components/User";
import Test from "./components/Test";
import Band from "./components/Band";
import Hr from "./components/Hr";
import HrEvent from "./components/HrEvent";
import HrBasic from "./components/HrBasic";

function App() {
  return (
    <RecoilRoot>
      <Router>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/member" component={Member} />
          <Route exact path="/user" component={User} />
          <Route exact path="/test" component={Test} />
          <Route exact path="/band" component={Band} />
          <Route exact path="/hr" component={Hr} />
          <Route exact path="/hrEvent" component={HrEvent} />
          <Route exact path="/hrBasic" component={HrBasic} />
        </Switch>
      </Router>
    </RecoilRoot>
  );
}

export default App;
